export default __webpack_public_path__ + "static/media/Kick1.3cf98bf7.mp3";